import { render, staticRenderFns } from "./panel-product-selector.vue?vue&type=template&id=016c3eda&scoped=true&"
import script from "./panel-product-selector.vue?vue&type=script&lang=js&"
export * from "./panel-product-selector.vue?vue&type=script&lang=js&"
import style0 from "./panel-product-selector.vue?vue&type=style&index=0&id=016c3eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c3eda",
  null
  
)

export default component.exports